var ctUnreadMessagesModel;
(function ($) {
 	$.fn.capitechUnreadMessages = function() {
		var $ctUnreadMessagesElm = $(this);
		var initUnreadMessageCount = parseInt(getLocalStorage('myCapitechUnReadMessageCount'));
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			displayUnreadMessages();
			getUnReadMessageCount();
			setInterval(function () {
				getUnReadMessageCount();
			}, 300000);
		}
		
		function displayUnreadMessages() {
			var modelData = {};
			modelData.unreadMessageCount = getLocalStorage('myCapitechUnReadMessageCount');
			
			ctUnreadMessagesModel = new unreadMessagesViewModel(modelData);
			$('*[data-ko-bind="ctUnreadMessagesModel"]').each(function(index, obj) {
				ko.applyBindings(ctUnreadMessagesModel, obj);
			});
		}
		
		function getUnReadMessageCount() {
			var success = function success(data, textStatus, jqXHR) {
				var unreadMessageCount = 0;
				if (data.success == true && data.content.length === 1) {
					unreadMessageCount = parseInt(data.content[0]);
					ctUnreadMessagesModel.unreadMessageCount(unreadMessageCount);
					if (initUnreadMessageCount < unreadMessageCount) {
						$('.ct-dialog-mobile-counter-wrapper').addClass('shake');
					} else {
						initUnreadMessageCount = unreadMessageCount;
						setLocalStorage('myCapitechUnReadMessageCount', unreadMessageCount);
						$('.ct-dialog-mobile-counter-wrapper').removeClass('shake');
					}
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				// Do nothing.
				// sweetAlert("Error", errorThrown, "error");
			};
			_api.getNumberOfPendingIncomingMessages_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME));
		}
		
		var unreadMessagesViewModel = function(properties) {
			// properties
			if(typeof(properties)==='undefined')					properties						= {};
			if(typeof(properties.unreadMessageCount)==='undefined')	properties.unreadMessageCount	= '';
			
			var self = this;
			self.unreadMessageCount	= ko.observable(properties.unreadMessageCount);
			self.unreadMessageCountAsText = ko.pureComputed(function() {
				
				if (self.unreadMessageCount() === 0) {
					return getResource('dialog.noneUnreadMessages', 'You have read all your messages');
				} else if (self.unreadMessageCount() === 1) {
					return getResource('dialog.oneUnreadMessage', 'You have one unread message');
				} else {
					return self.unreadMessageCount() + ' ' + getResource('dialog.manyOrNoneUnreadMessages', 'unread messages');
				}
			}, self);
		};

		// init
		/*////////////////////////////////////////////////////////////*/
		init();
	};
}(jQuery));